<div class="field-group-layout">
  <!-- GOOGLE MAPS SEARCH -->
  @if (!readonly) {
    <google-places-search-field
      [country]="selectedCountry"
      searchControlName="searchRefCode"
      searchControlLabel="REGISTRATION.ADDRESS.SEARCH"
      searchControlPlaceholder="REGISTRATION.ADDRESS.SUBFORM.DEFAULT.SEARCH_PLACEHOLDER"
      (resultSelected)="mapSearchResult($event)" />
  }

  <input type="hidden" [formControl]="addressFormGroup.controls.searchRefCode" />

  <!-- LINE 1 -->
  <soldo-field-layout
    cypressSelector="Address_TextInput_Line1"
    [control]="addressFormGroup.controls.line1"
    fieldName="line1"
    label="REGISTRATION.ADDRESS.LINE_1_LABEL">

    <input input type="text"
      name="line1"
      [formControl]="addressFormGroup.controls.line1"
      [readOnly]="readonly"
      placeholder="{{ 'REGISTRATION.ADDRESS.SUBFORM.DEFAULT.LINE_1_PLACEHOLDER' | translate }}"
      [ngClass]="{autofilled: showingSearchResult}">

    <ng-container errorMessage>
      <soldo-field-error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
      <soldo-field-error errorName="maxlength">{{ 'MAX_LENGHT' | translate: { value:
        addressFormGroup.get('line1').errors?.maxlength?.requiredLength } }}</soldo-field-error>
    </ng-container>
  </soldo-field-layout>

  <!-- LINE 2 -->
  <soldo-field-layout
    cypressSelector="Address_TextInput_Line2"
    [control]="addressFormGroup.controls.line2"
    fieldName="line2"
    label="REGISTRATION.ADDRESS.LINE_2_LABEL">

    <input input type="text"
      [formControl]="addressFormGroup.controls.line2"
      name="line2"
      [readOnly]="readonly">

    <ng-container errorMessage>
      <soldo-field-error errorName="maxlength">{{ 'MAX_LENGHT' | translate: { value:
        addressFormGroup.get('line2').errors?.maxlength?.requiredLength } }}</soldo-field-error>
    </ng-container>
  </soldo-field-layout>

  <!-- ADDRESS POSTCODE -->
  <soldo-field-layout
    cypressSelector="Address_TextInput_Postcode"
    [control]="addressFormGroup.controls.postalCode"
    fieldName="postalCode" label="REGISTRATION.ADDRESS.SUBFORM.DEFAULT.POSTCODE_LABEL">

    <input input type="text"
      [formControl]="addressFormGroup.controls.postalCode"
      name="postalCode"
      uppercase
      [readOnly]="readonly"
      [ngClass]="{autofilled: showingSearchResult}">

    <ng-container errorMessage>
        <soldo-field-error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
        <soldo-field-error errorName="maxlength">{{ 'MAX_LENGHT' | translate:{value: addressFormGroup.get('postalCode').errors?.maxlength?.requiredLength} }}</soldo-field-error>
        <soldo-field-error errorName="pattern">{{ 'WRONG_FORMAT' | translate }}</soldo-field-error>
    </ng-container>
  </soldo-field-layout>

  <!-- ADDRESS PROVINCE -->
  <soldo-field-layout
    cypressSelector="Address_TextInput_Province"
    [control]="addressFormGroup.controls.province"
    fieldName="province" label="REGISTRATION.ADDRESS.SUBFORM.DEFAULT.PROVINCE_LABEL">

    <input input type="text"
      [formControl]="addressFormGroup.controls.province"
      name="province"
      [readOnly]="readonly"
      [ngClass]="{autofilled: showingSearchResult}">

    <ng-container errorMessage>
      <soldo-field-error errorName="maxlength">{{ 'MAX_LENGHT' | translate:{value: addressFormGroup.get('province').errors?.maxlength?.requiredLength} }}</soldo-field-error>
    </ng-container>
  </soldo-field-layout>

  <!-- ADDRESS TOWN -->
  <soldo-field-layout
    cypressSelector="Address_TextInput_City"
    [control]="addressFormGroup.controls.city"
    fieldName="city" label="REGISTRATION.ADDRESS.CITY_LABEL">

    <input input type="text"
      [formControl]="addressFormGroup.controls.city"
      name="city"
      [readOnly]="readonly"
      [ngClass]="{autofilled: showingSearchResult}">

    <ng-container errorMessage>
      <soldo-field-error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
      <soldo-field-error errorName="maxlength">{{ 'MAX_LENGHT' | translate:{value: addressFormGroup.get('city').errors?.maxlength?.requiredLength} }}</soldo-field-error>
    </ng-container>
  </soldo-field-layout>
</div>
